import { createAction, props } from '@ngrx/store';

import { NavSegments, uuid } from '@aw/shared/models';

import { BusinessUnit } from '@aw/prypco/enums';
import { BlocksLead } from '@aw/prypco/modules/blocks/services/blocks';
import {
  AccountState,
  AccountStates,
  ExternalIdentifier,
} from '@aw/prypco/services/user';

import { LeadIdRecord } from './models/entities/lead-id-record.model';
import { LeadRecord } from './models/entities/lead-record.model';
import { MemberInfoCustomer } from './models/entities/member-info.model';

export const init = createAction('[Auth] Init');

export const setMemberInfo = createAction(
  '[Auth] Set Member Info',
  props<{
    leadIdRecord: LeadIdRecord;
    leadRecord: LeadRecord;
    accountStates?: Record<BusinessUnit, AccountStates>;
    externalIdentifiers: Array<ExternalIdentifier>;
    customer?: MemberInfoCustomer;
  }>(),
);

export const signUp = createAction(
  '[Auth] Sign Up',
  props<{ redirectUri: Array<string> }>(),
);

export const signUpSalesAgent = createAction(
  '[Auth] Sign Up Sales Agent',
  props<{ redirectUri: Array<string> }>(),
);

export const logOut = createAction(
  '[Auth] Log Out',
  props<{ businessUnit?: BusinessUnit; redirectUri?: NavSegments }>(),
);

export const signIn = createAction(
  '[Auth] Sign In',
  props<{ redirectUri: NavSegments }>(),
);

export const setLeadId = createAction(
  '[Auth] Set Lead ID',
  props<{ leadId: uuid; businessUnit: BusinessUnit }>(),
);

export const setLead = createAction(
  '[Auth] Set Lead',
  props<{ lead: LeadRecord; businessUnit: BusinessUnit }>(),
);

export const refreshAccountStates = createAction(
  '[Auth] Refresh account states',
);

export const setAccountStates = createAction(
  '[Auth] Set account states',
  props<{
    accountStates?: Record<
      BusinessUnit,
      Partial<Record<AccountState, boolean>>
    >;
  }>(),
);

export const setAccountState = createAction(
  '[Auth] Set account state',
  props<{
    businessUnit: BusinessUnit;
    accountState: AccountState;
    value: boolean;
  }>(),
);

export const setInitialized = createAction('[Auth] Set Initialized');

export const setRemoteConfig = createAction(
  '[Auth] Set Remote Config',
  props<{ config: Record<string, any> }>()
);

